import { immerable } from "immer";

export class OrderKey {
    [immerable] = true
    public id: string | undefined;
    public containerId: string | undefined;
    public slotId: string | undefined;
}
